import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function EditAttendance() {
    const { some } = useParams();
    const location = useLocation();
    
    const query = new URLSearchParams(location.search);
    const empmobile = query.get('empmobile');
    const { branchId } = useParams();
    const employeeName = query.get('employeeName');
    const selectedDate = query.get('date');
    const adminmob = localStorage.getItem('adminmob');
    const [punchData, setPunchData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPhoto, setCurrentPhoto] = useState('');
    const udiseNumber = localStorage.getItem("udiseNumber");
    const navigate = useNavigate();
     const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');

      useEffect(() => {
                 const storedLanguage = localStorage.getItem('language') || 'English';
                 setLanguage(storedLanguage);
               }, []);
    
    const fetchPunchData = async () => {
        const punchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance/${selectedDate}/punches.json`;
        console.log("punchUrl", punchUrl);
        
        try {
            const response = await fetch(punchUrl);
            if (response.ok) {
                const data = await response.json();
                console.log("Fetched Data:", data);
                
                const formattedData = Object.keys(data)
                    .filter(key => data[key] !== null)
                    .map((key, index) => ({
                        serialNumber: index + 1,
                        punchIn: data[key].punch_in || "-",
                        punchOut: data[key].punch_out || "-",
                        punchLoc: data[key].punch_in_loc || "-",
                        punchImg: data[key].punch_in_img || "-",
                        punchImg1: data[key].punch_out_img || "-"
                    }));
                setPunchData(formattedData);
            } else {
                console.error("Failed to fetch Punch data:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching Punch data:", error);
        }
    };
    
    useEffect(() => {
        fetchPunchData();
    }, [adminmob, empmobile, selectedDate, branchId]);
    
    const handleClose = () => {
        navigate(-1);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

const updateAttendanceStatus = async (status) => {
        const statusUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance/${selectedDate}/status.json`;
        console.log("statusUrl",statusUrl);
        
        try {
            if (status === 'ABSENT') {
                const response = await fetch(statusUrl, {
                    method: 'DELETE', // Use DELETE to delete the status
                });
                if (response.ok) {
                    console.log("Status removed successfully");
                    setAttendanceStatus(''); // Update the attendance status to empty string
                } else {
                    console.error("Failed to remove status:", response.statusText);
                }
            } else {
                const response = await fetch(statusUrl, {
                    method: 'PATCH', // Use PATCH to update the status
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(status), // Send the status as JSON
                });
                if (response.ok) {
                    console.log("Status updated successfully");
                    setAttendanceStatus(status); // Update the attendance status
                } else {
                    console.error("Failed to update status:", response.statusText);
                }
            }
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    const [attendanceStatus, setAttendanceStatus] = useState('');

    useEffect(() => {
        const fetchAttendanceStatus = async () => {
            const attendanceStatusUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData/${empmobile}/Attendance/${selectedDate}.json`;
            console.log("attendanceStatusUrl", attendanceStatusUrl);
            
            try {
                const response = await fetch(attendanceStatusUrl);
                if (response.ok) {
                    const data = await response.json();
                    console.log("Fetched Attendance Status:", data);
                    setAttendanceStatus(data.status);
                } else {
                    console.error("Failed to fetch Attendance Status:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching Attendance Status:", error);
            }
        };
        
        fetchAttendanceStatus();
    }, [adminmob, empmobile, selectedDate, branchId]);

    return (
            <div className="main-content-of-page" style={{ padding: '20px', backgroundColor: '#eaf7ff' }}>
                <button 
                    style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '20px', float: 'right', marginBottom: '10px' }} 
                    onClick={handleClose}
                >
                    X
                </button>
                <h1 style={{ textAlign: 'center', color: '#333',fontSize:'20px',border:'2px solid black',borderRadius:'6px',width:'30%',margin:'auto',padding:'4px',backgroundColor:'#fceef0' }}>{language === "English" ? "Teacher Name :" : "शिक्षकाचे नाव :"} {employeeName}</h1>
                <h3 style={{ textAlign: 'center', color: '#333',fontSize:'19px',padding:'10px' }}>{language === "English" ? "Date :" : "तारीख :"} {selectedDate}</h3>
                   
                <div className="attendance-status" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px',width:'70%',textAlign:'center',alignItems:'center' }}>
                    <div className="status-column" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <p className="status-item" style={{ margin: '0 10px', border: '1px solid red', backgroundColor: attendanceStatus === 'ABSENT' ? '#e9f5ff' : '', color: attendanceStatus === 'ABSENT' ? '#007bff' : '', padding: '10px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s', cursor: 'pointer' }} onClick={() => updateAttendanceStatus('ABSENT')}>{language === "English" ? "ABSENT " : "अनुपस्थित"}</p>
                        <p className="status-item" style={{ margin: '0 10px', border: '1px solid green', backgroundColor: attendanceStatus === 'Full' ? 'green' : '', color: attendanceStatus === 'Full' ? 'white' : '', padding: '10px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s', cursor: 'pointer' }} onClick={() => updateAttendanceStatus('Full')}>{language === "English" ? "PRESENT " : "उपस्थित"}</p>
                        <p className="status-item" style={{ margin: '0 10px', border: '1px solid #007bff', backgroundColor: attendanceStatus === 'HOLIDAY' ? '#e9f5ff' : '', color: attendanceStatus === 'HOLIDAY' ? '#007bff' : '', padding: '10px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s', cursor: 'pointer' }} onClick={() => updateAttendanceStatus('HOLIDAY')}>{language === "English" ? "HOLIDAY " : "सुट्टी"}</p>
                        <p className="status-item" style={{ margin: '0 10px', border: '1px solid yellow', backgroundColor: attendanceStatus === 'Half' ? 'yellow' : '', color: attendanceStatus === 'Half' ? 'black' : '', padding: '10px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s', cursor: 'pointer' }} onClick={() => updateAttendanceStatus('Half')}>{language === "English" ? "HALF DAY" : "अर्धा दिवस "}</p>
                        <p className="status-item" style={{ margin: '0 10px', border: '1px solid #007bff', backgroundColor: attendanceStatus === 'WEEK OFF' ? '#e9f5ff' : '', color: attendanceStatus === 'WEEK OFF' ? '#007bff' : '', padding: '10px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s', cursor: 'pointer' }} onClick={() => updateAttendanceStatus('WEEK OFF')}>{language === "English" ? "WEEK OFF" : "आठवडा सुट्टी "}</p>
                    </div>
                </div>

                <h2 style={{ marginTop: '20px', borderTop: '1px solid #ccc',fontSize:'24px' }}>{language === "English" ? "Leaves" : "रजा"}</h2>
                <div className="leaves-column" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <div className="status-column" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <p className="leave-item" style={{ margin: '0 10px', border: '1px solid #28a745', backgroundColor: '#e9f5e9', color: '#28a745', padding: '10px', width: '140px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s' }}>{language === "English" ? "PAID LEAVE" : "सशुल्क रजा"}</p>
                        <p className="leave-item" style={{ margin: '0 10px', border: '1px solid #28a745', backgroundColor: '#e9f5e9', color: '#28a745', padding: '10px', width: '140px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s' }}>{language === "English" ? "UNPAID LEAVE" : "विनापगारी रजा"}</p>
                        <p className="half-day-leave" style={{ margin: '0 10px', border: '1px solid #28a745', backgroundColor: '#e9f5e9', color: '#28a745', padding: '10px', width: '150px', textAlign: 'center', borderRadius: '4px', transition: 'background-color 0.3s, color 0.3s' }}>{language === "English" ? "HALF DAY LEAVE" : "अर्धा दिवस सुट्टी"}</p>
                    </div>
                </div>

                <h3 style={{ margin: '20px 0', borderBottom: '1px solid #ccc' }}></h3>

                <div className="attendance-columns" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                    {punchData.map((item, index) => (
                        <div key={index} style={{ border: '1px solid black', borderRadius: '8px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px', width: '70%',backgroundColor:'#fceef0' }}>
                            <div style={{ display: 'flex' }}>
                                <img 
                                    src={item.punchImg} 
                                    alt="Punch In" 
                                    style={{ width: '100px', height: '100px', borderRadius: '50%', marginBottom: '10px', marginRight: '70px' }} 
                                    onClick={() => { setCurrentPhoto(item.punchImg); setIsModalOpen(true); }}
                                />
                                <div>
                                    <p style={{ margin: '0', color: item.punchIn ? 'green' : 'red' }}>Punch In: {item.punchIn}</p>
                                    <p style={{ margin: '0' }}>{item.punchLoc}</p>
                                </div>
                            </div>
                            <hr style={{ width: '100%', border: '1px dashed #ccc', margin: '10px 0' }} />
                            <div style={{ display: 'flex' }}>
                                <img 
                                    src={item.punchImg1} 
                                    alt="Punch Out" 
                                    style={{ width: '100px', height: '100px', borderRadius: '50%', marginBottom: '10px', marginRight: '70px' }} 
                                    onClick={() => { setCurrentPhoto(item.punchImg1); setIsModalOpen(true); }}
                                />
                                <div>
                                    <p style={{ margin: '0', color: item.punchOut ? 'red' : 'green' }}>Punch Out: {item.punchOut}</p>
                                    <p style={{ margin: '0' }}>{item.punchLoc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                    {isModalOpen && (
                        <div className="modal" style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div className="" style={{ position: 'relative', backgroundColor: '#fff', padding: '20px', borderRadius: '8px' }}>
                                <span onClick={closeModal} style={{ position: 'absolute', top: '0px', right: '10px', cursor: 'pointer', fontSize: '20px', color: "red" }}>✖</span>
                                <img src={currentPhoto} alt="Modal" style={{ maxWidth: '300px', maxHeight: 'auto', borderRadius: '8px' }} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
    
    );
}

export default EditAttendance;